const SUPPORTED_PATHS = [
  /^\/$/,
  /^\/sport\/(nba|soccer|nfl|mlb|nhl)(\/upcoming)?$/,
  /^\/plan$/,
  /^\/settings$/,
  /^\/upcoming$/,
];

export function routeForMobileLink(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    if (url.protocol === 'skore:') {
      const nativePath = `/${url.hostname}${url.pathname}`.replace(/\/+$/, '') || '/';
      return SUPPORTED_PATHS.some((pattern) => pattern.test(nativePath))
        ? `${nativePath}${url.search}`
        : null;
    }
    if (!['skore.info', 'www.skore.info'].includes(url.hostname)) return null;
    if (url.protocol !== 'https:') return null;
    return SUPPORTED_PATHS.some((pattern) => pattern.test(url.pathname))
      ? `${url.pathname}${url.search}`
      : null;
  } catch {
    return null;
  }
}
